import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { getForcedGlobalClassnamesForContext, getComponentName } from './helpers';
import { ThemeOptions, ThemeSkin } from './constants';
export const ThemeContext = /*#__PURE__*/ React.createContext(undefined);
ThemeContext.displayName = 'ThemeContext';
export const ThemeSkinContext = /*#__PURE__*/ React.createContext(undefined);
ThemeSkinContext.displayName = 'ThemeSkinContext';
export function useSelectByTheme({ dark , light , green =light  }) {
    const theme = useContext(ThemeContext);
    const themeSkin = useContext(ThemeSkinContext);
    if (theme === ThemeOptions.DARK) {
        return dark;
    }
    if (themeSkin === ThemeSkin.GREEN) {
        return green;
    }
    return light;
}
// HOC for convenience...
export function withThemeContext(Component) {
    const DecoratedComponent = (props)=>{
        const theme = useContext(ThemeContext);
        return /*#__PURE__*/ React.createElement(Component, _extends({
            theme: theme
        }, props));
    };
    DecoratedComponent.displayName = `withThemeContext(${getComponentName(Component)})`;
    return DecoratedComponent;
}
// and for overriding theme...
export const ThemeOverride = (_param)=>{
    var { children , theme , className , tag: Tag = 'span'  } = _param, rest = _object_without_properties(_param, [
        "children",
        "theme",
        "className",
        "tag"
    ]);
    if (theme === 'match') {
        return /*#__PURE__*/ React.createElement(Tag, {
            className: className
        }, children);
    }
    return /*#__PURE__*/ React.createElement(ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ React.createElement(Tag, _extends({
        className: classnames(className, getForcedGlobalClassnamesForContext({
            theme
        }))
    }, rest), children));
};
ThemeOverride.displayName = 'ThemeOverride';
export const useReverseTheme = ()=>{
    const theme = useContext(ThemeContext);
    const flippedTheme = theme === ThemeOptions.LIGHT ? ThemeOptions.DARK : ThemeOptions.LIGHT;
    return flippedTheme;
};
export const ReverseTheme = ({ children , className , tag  })=>{
    const flippedTheme = useReverseTheme();
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: flippedTheme,
        className: className,
        tag: tag
    }, children);
};
ReverseTheme.displayName = 'ReverseTheme';
// re-export to avoid changing a billion imports again...
export { ThemeOptions, ThemeSkin };
